import React from 'react';
import { connect } from 'react-redux';
import { toggleSecondModalClose } from '../../storage/actions/modalsActions';

const GoogleMapsModal = ({ modalState, currentWorkOrder, toggleSecondModalClose }) => {
  const closeModal = () => toggleSecondModalClose('googleMapsModal', true);

  if (!currentWorkOrder || !modalState.isOpen) return null;

  const position = {
    lat: currentWorkOrder.coords.coordinates[1],
    lng: currentWorkOrder.coords.coordinates[0],
  };

  const embedUrl = `https://maps.google.com/maps?q=${position.lat},${position.lng}&z=15&output=embed`;
  const openUrl = `https://www.google.com/maps/search/?api=1&query=${position.lat},${position.lng}`;

  return (
    <div
      className="modal_block dashboard-modal dashboard-modal--centered modal_import google-maps-modal showed"
      role="presentation"
      onClick={closeModal}
    >
      <div
        className="modal_container"
        role="dialog"
        aria-modal="true"
        aria-label="Google Map"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal_head google-maps-modal__head">
          <button
            type="button"
            className="close_btn icon_close"
            aria-label="close"
            onClick={closeModal}
          />
        </div>
        <div className="modal_body">
          <div className="google-maps-modal__map">
            <iframe
              title="Google Map"
              className="google-maps-modal__iframe"
              src={embedUrl}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
          <div className="google-maps-modal__footer">
            <a
              href={openUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="google-maps-modal__link"
            >
              Open in Google Maps
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  currentWorkOrder: state.workOrder.currentWorkOrder,
  modalState: state.modalState.googleMapsModal,
});

export default connect(mapStateToProps, { toggleSecondModalClose })(GoogleMapsModal);
